module.exports = __webpack_public_path__ + "img/threewaterbottle.4aa07bf0.jpg";